import { Component } from '@angular/core';
// Moved to Master > Settings page: import { CountryCodes } from './business-profile.models';
import { MasterService } from '@11za/app/core/services/master/master.service';
import { AccountDataRes, Daum } from '@11za/app/core/models/business-profile/accountDataRes';
import { ProfileDataRes, Data as ProfileDataData } from '@11za/app/core/models/business-profile/profileDataRes';
import { swalHelper } from '@11za/app/core/constants/swal-helper';
import { environment } from '@11za/environments/env.dev';
import { InitialService } from '@11za/app/core/services/initial/initial.service';
@Component({
  selector: 'app-business-profile',
  templateUrl: './business-profile.component.html',
  styleUrl: './business-profile.component.scss',
  standalone: false
})
export class BusinessProfileComponent {
  forClient = environment.forClient
  // Moved to Master > Settings page: countries: CountryCodes[] = []
  selectedFile: File | null = null
  previewUrl: string | ArrayBuffer | null = null;
  isIframe = this.initialService.isIframe
  /*onFileSelected(event: Event) {
    //(minimum 500px, x 500px, recommended 640px x 640px, max 5 MB)  and alurt
    const input = event.target as HTMLInputElement;

    if (input?.files?.length) {
      const file = input.files[0];

      if (file.size > 5 * 1024 * 1024) {
        swalHelper.warning('File size must not exceed 5 MB.');
        return;
      }

      const image = new Image();
      const reader = new FileReader();

      reader.onload = (e: any) => {
        image.src = e.target.result;

        image.onload = () => {
          const { width, height } = image;

          if (width < 500 || height < 500) {
            swalHelper.warning('Image dimensions must be at least 500px x 500px. it can be crop');
            return;
          }

          if (width < 640 || height < 640) {
            swalHelper.warning('Recommended dimensions are at least 640px x 640px.');
            return;
          }
          // Validation passed
          this.selectedFile = file;
          this.previewUrl = e.target.result; // Set preview URL for the selected image
        };
      };

      reader.readAsDataURL(file);
    }else{
      this.previewUrl = null
    }
  } */
  onLogoLoadError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img) {
      img.style.display = 'none';
    }
  }
  CompanyProfilePermission = {
    delete: false,
    export: false,
    insertUpdate: false,
    view: true,
  };
  setPermission() {
    this.initialService.getPermission.subscribe((e) => {
      if (e?.companyProfile)
        this.CompanyProfilePermission = e?.companyProfile;
    });
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (!input?.files?.length) {
      this.selectedFile = null;
      this.previewUrl = null;
      return;
    }

    const file = input.files[0];
    if (file.size > 5 * 1024 * 1024) {
      swalHelper.warning('File size must not exceed 5 MB.');
      (event.target as HTMLInputElement).value = '';
      return;
    }
    if (!/^image\//.test(file.type)) {
      swalHelper.warning('Please select a valid image file.');
      (event.target as HTMLInputElement).value = '';
      return;
    }

    const image = new Image();
    const reader = new FileReader();
    reader.onload = (e: any) => {
      image.src = e.target.result;
      image.onload = () => {
        const { width, height } = image;
        if (width < 500 || height < 500) {
          swalHelper.warning('Image dimensions must be at least 500px × 500px.');
          this.selectedFile = null;
          this.previewUrl = null;
          (event.target as HTMLInputElement).value = '';
          return;
        }
        if (width !== height) {
          swalHelper.warning('Image is not square and will be cropped by WhatsApp. Recommended 640px × 640px.');
        }
        this.selectedFile = file;
        this.previewUrl = e.target.result;
      };
    };
    reader.readAsDataURL(file);
  }
  async saveChanges() {
    try {
      if (this.selectedFile && this.previewUrl) {
        const form = new FormData();
        form.append("businessLogo", this.selectedFile);
        const logoRes = await this.masterService.updateProfileDatawithLogo(form);
        if (!logoRes?.IsSuccess) {
          throw new Error(logoRes?.Message || "Failed to upload logo.");
        }
        swalHelper.success("profilepic updated", logoRes.Message);
        this.selectedFile = null;
        this.previewUrl = null;
      }
      /* Moved to Master > Settings page
      if (!this.profileData?.businessDetails?.defaultcountry) {
        this.profileData.businessDetails.defaultCountryCode = "91";
      }

      if (!this.profileData.businessDetails.defaultcountry) {
        this.profileData.businessDetails.defaultCountryCode = "91";
      }
      */

      // businessHours, queueMessageDays, archiveMessageDays and businessDetails.defaultcountry/defaultCountryCode
      // are now managed on the Master > Settings page (settings/settingsUpdate API) — excluded here.
      const { businessHours, queueMessageDays, archiveMessageDays, ...restProfileData } = this.profileData;
      const { defaultcountry, defaultCountryCode, ...restBusinessDetails } = restProfileData.businessDetails;
      const payload = { ...restProfileData, businessDetails: restBusinessDetails };

      const profileRes = await this.masterService.updateProfileData(payload);
      if (profileRes?.IsSuccess && profileRes?.Data) {
        swalHelper.success("profile data updated", profileRes.Message);
      } else {
        throw new Error(profileRes?.Message || "🤔 something wrong.");
      }
      this.getProfileData();
    } catch (err) {
      swalHelper.error(err);
    }
  }

  selectedCountry: string | undefined; // Holds the selected countrycallingcode
  originalProfileData: ProfileDataData | null = null
  ngOnInit() {
    // Moved to Master > Settings page: this.countrieslist()
    this.getAccountData()
    this.getProfileData()
    this.setPermission()
  }
  isSync = false
  syncChanges() {
    this.isSync = true
    this.getProfileData()
  }
  resetChanges() {
    if (!this.originalProfileData) {
      return
    }
    this.profileData = JSON.parse(JSON.stringify(this.originalProfileData)) as ProfileDataData
    this.selectedFile = null
    this.previewUrl = null
  }
  accountData: Daum[] = []
  profileData!: ProfileDataData
  getProfileData() {
    this.masterService.getProfileData({ isSync: this.isSync })
      .then((result) => {
        // this.profileData = { ...result.Data }
        const data = { ...result.Data || {} }
        const businessDetails = {
          ...data.businessDetails,
          websites: data.businessDetails?.websites || ['', '']
        };
        this.profileData = { ...data, businessDetails }
        this.originalProfileData = JSON.parse(JSON.stringify(this.profileData)) as ProfileDataData
      }).catch((err) => {
        console.error(err);
      });
  }
  async getAccountData() {
    const accountData = await this.masterService.getAccountData()
    this.accountData = accountData.Data
  }
  /* Moved to Master > Settings page
  async countrieslist() {
    const countrieslist = await this.masterService.countrieslist()
    this.countries = countrieslist.Data
  }
  */

  constructor(private masterService: MasterService, public initialService: InitialService) {
    // Moved to Master > Settings page
    // this.countries.forEach(country => {
    //   country.displayLabel = `+${country.countrycallingcode} ${country.countryname}`;
    // });
  }
}
